export default __webpack_public_path__ + "static/media/Inter-UI-Bold.4c93833c.woff2";